import { render, staticRenderFns } from "./AddWaffle.vue?vue&type=template&id=4984e942&scoped=true&"
import script from "./AddWaffle.vue?vue&type=script&lang=js&"
export * from "./AddWaffle.vue?vue&type=script&lang=js&"
import style0 from "./AddWaffle.vue?vue&type=style&index=0&id=4984e942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4984e942",
  null
  
)

export default component.exports